import { render, staticRenderFns } from "./PortalBrandingHarnessPage.vue?vue&type=template&id=1477c658&scoped=true&"
import script from "./PortalBrandingHarnessPage.vue?vue&type=script&lang=js&"
export * from "./PortalBrandingHarnessPage.vue?vue&type=script&lang=js&"
import style0 from "./PortalBrandingHarnessPage.vue?vue&type=style&index=0&id=1477c658&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477c658",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VDataTable,VRadio,VRadioGroup,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1477c658')) {
      api.createRecord('1477c658', component.options)
    } else {
      api.reload('1477c658', component.options)
    }
    module.hot.accept("./PortalBrandingHarnessPage.vue?vue&type=template&id=1477c658&scoped=true&", function () {
      api.rerender('1477c658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dev/PortalBrandingHarnessPage.vue"
export default component.exports